import { css } from "styled-components";

const ptSerif_body_base = css`
  font-family: var(--font-pt-serif);
  font-style: normal;
  letter-spacing: 0;
`;

export const ptSerif_body_lg_bold = css`
  ${ptSerif_body_base};
  font-size: var(--text-body-size-lg);
  font-weight: var(--text-weight-bold);
  line-height: 2.4rem;
`;

export const ptSerif_body_lg_regular = css`
  ${ptSerif_body_base};
  font-size: var(--text-body-size-lg);
  font-weight: var(--text-weight-regular);
  line-height: 2.4rem;
`;

export const ptSerif_body_md_bold = css`
  ${ptSerif_body_base};
  font-size: var(--text-body-size-md);
  font-weight: var(--text-weight-bold);
  line-height: 1.96rem;
`;

export const ptSerif_body_md_regular = css`
  ${ptSerif_body_base};
  font-size: var(--text-body-size-md);
  font-weight: var(--text-weight-regular);
  line-height: 1.96rem;
`;

export const ptSerif_body_sm_bold = css`
  ${ptSerif_body_base};
  font-size: var(--text-body-size-sm);
  font-weight: var(--text-weight-bold);
  line-height: 1.56rem;
`;

export const ptSerif_body_sm_regular = css`
  ${ptSerif_body_base};
  font-size: var(--text-body-size-sm);
  font-weight: var(--text-weight-regular);
  line-height: 1.56rem;
`;
